var _defs, _path, _path2, _g, _path3, _path4, _path5, _path6, _g2, _g3, _g4, _rect, _rect2, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrations03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ff4374;\n      }\n\n      .st1 {\n        fill: #d7bbff;\n      }\n\n      .st2 {\n        fill: #ffb043;\n      }\n\n      .st3 {\n        fill: #fbd072;\n      }\n\n      .st4, .st5 {\n        fill: #fff;\n      }\n\n      .st6 {\n        fill: #efe6ff;\n      }\n\n      .st7 {\n        fill: none;\n      }\n\n      .st8 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st9 {\n        fill: #28287f;\n      }\n\n      .st10 {\n        fill: #42166d;\n      }\n\n      .st5 {\n        stroke: #42166d;\n        stroke-miterlimit: 10;\n        stroke-width: .5px;\n      }\n\n      .st11 {\n        fill: #b095db;\n      }\n\n      .st12 {\n        fill: #b8b8f5;\n      }\n\n      .st13 {\n        fill: #00c7b3;\n      }\n\n      .st14 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M162.17,325.64c-13.33,5.12-26.4,5.58-29.2,1.03-2.8-4.55,5.74-12.39,19.07-17.52,13.33-5.12,26.4-5.58,29.2-1.03,2.8,4.55-5.74,12.39-19.07,17.52Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 323.02,
    cy: 212.85,
    r: 25.92
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M179.94,187.31c-4.81,0-9.92-1.18-15.01-3.51-7.55-3.46-14.01-8.83-20.25-14.02-5.52-4.59-10.58-9.23-11.9-15.56-1.1-5.28.75-11.44,4.96-16.47,3.76-4.5,8.89-7.77,13.82-10.74,5.9-3.55,12.82-7.53,20.34-9.75,5.66-1.67,14.13-3.02,22.37.06,22.82,8.51,15.55,38.36,12.77,47.31-3.15,10.15-9.85,18.03-17.93,21.08-2.85,1.08-5.94,1.61-9.18,1.61ZM183.62,116.23c-4.35,0-8.37.83-11.5,1.75-7.43,2.19-14.3,6.14-20.16,9.67-5.07,3.06-9.93,6.16-13.63,10.58-4.06,4.86-5.86,10.77-4.8,15.82,1.27,6.09,6.23,10.64,11.65,15.13,6.21,5.16,12.62,10.49,20.08,13.91,8.32,3.81,16.7,4.48,23.6,1.88,7.86-2.96,14.39-10.66,17.47-20.59,2.72-8.78,9.88-38.09-12.31-46.37h0c-3.5-1.3-7.04-1.79-10.38-1.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M337.59,126.28c-19.17,1.86-37.72,11.59-49.72,27.52-11.99,15.92-16.24,37.48-34.32,48.59-22.84,14.04-49.02,1.1-73.5,1.29-25.3.2-50.54,11.54-66.91,30.95-17.75,21.05-24.39,50.78-17.94,77.47,7.84,32.45,37.48,56.3,68.08,66.46,36.15,12,79.48,5.96,109.29-18.4,11.65-9.52,20.77-21.92,25.97-36.07,7.97-21.71,7.72-48.37,25.27-63.41,13.94-11.95,34.32-12.01,51.03-19.59,39.94-18.12,42.35-73.7,10.41-100.52-13.71-11.51-30.91-15.9-47.66-14.27Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 132.05,
    y: 329.41,
    width: 0.76,
    height: 11.58,
    transform: "translate(-103.65 62.87) rotate(-19.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 126.65,
    y: 329.17,
    width: 0.76,
    height: 8.44,
    transform: "translate(-103.35 60.97) rotate(-19.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 139.49,
    y: 330.34,
    width: 0.76,
    height: 11.58,
    transform: "translate(-103.53 65.38) rotate(-19.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 146.63,
    y: 330.42,
    width: 0.76,
    height: 11.58,
    transform: "translate(-103.15 67.75) rotate(-19.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 153.25,
    y: 329.03,
    width: 0.76,
    height: 11.58,
    transform: "translate(-102.32 69.88) rotate(-19.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 159.57,
    y: 326.8,
    width: 0.76,
    height: 11.58,
    transform: "translate(-101.23 71.85) rotate(-19.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 171.34,
    y: 321.74,
    width: 0.76,
    height: 11.58,
    transform: "translate(-98.87 75.46) rotate(-19.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 177.03,
    y: 318.44,
    width: 0.76,
    height: 11.58,
    transform: "translate(-97.46 77.16) rotate(-19.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 182.61,
    y: 315.17,
    width: 0.76,
    height: 10.88,
    transform: "translate(-95.95 78.81) rotate(-19.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 187.86,
    y: 311.95,
    width: 0.76,
    height: 8.21,
    transform: "translate(-94.15 80.29) rotate(-19.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 165.9,
    y: 324.58,
    width: 0.76,
    height: 11.58,
    transform: "translate(-100.13 73.82) rotate(-19.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M142.89,341.92c-6.54,0-11.86-1.42-14.73-4.27l-.06-.06-2.18-6.2.72-.25,2.12,6.04c5.79,5.64,21.85,5.31,37.44-.8,15.28-5.99,25.89-15.97,24.72-23.23l-1.99-5.66.72-.25,1.85,5.27.07-.04.09.51c1.3,7.74-9.29,17.88-25.18,24.11-8.22,3.22-16.59,4.84-23.58,4.84Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164.15,329.32c-17.54,6.74-34.74,7.35-38.42,1.36-3.68-5.99,7.55-16.31,25.09-23.05,17.54-6.74,34.74-7.35,38.42-1.36,3.68,5.99-7.55,16.31-25.09,23.05Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M162.17,358.28c-13.33,5.12-26.4,5.58-29.2,1.03-2.8-4.55,5.74-12.39,19.07-17.52,13.33-5.12,26.4-5.58,29.2-1.03,2.8,4.55-5.74,12.39-19.07,17.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M133.46,328.6c-.55-.86-.64-1.86-.28-3,1.4-4.32,9.48-10.02,20.1-14.19,13.75-5.39,26.6-6.36,29.26-2.22l-.64.41c-2.39-3.72-15.37-2.57-28.34,2.52-10.26,4.02-18.34,9.66-19.65,13.71-.29.9-.23,1.69.19,2.35l-.64.41Z"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M278.98,372.21h-110.58c-3.1,0-5.61-2.51-5.61-5.61l17.28-195.26c0-3.1,2.51-5.61,5.61-5.61h110.58c3.1,0,5.61,2.51,5.61,5.61l-17.28,195.26c0,3.1-2.51,5.61-5.61,5.61Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M287.62,372.59h-110.58c-3.31,0-5.99-2.69-5.99-5.99l17.28-195.29c0-3.27,2.69-5.96,5.99-5.96h110.58c3.31,0,5.99,2.69,5.99,5.99l-17.28,195.29c0,3.27-2.69,5.96-5.99,5.96ZM194.32,166.11c-2.88,0-5.23,2.35-5.23,5.23l-17.28,195.29c0,2.85,2.35,5.2,5.23,5.2h110.58c2.88,0,5.23-2.35,5.23-5.23l17.28-195.29c0-2.85-2.35-5.2-5.23-5.2h-110.58Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M275.05,367.93h-102.72c-2.44,0-4.42-1.98-4.42-4.42l17.28-187.93c0-2.44,1.98-4.42,4.42-4.42h102.72c2.44,0,4.42,1.98,4.42,4.42l-17.28,187.93c0,2.44-1.98,4.42-4.42,4.42Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M218.86,168.27h44.22c0,5.16-4.19,9.35-9.35,9.35h-25.51c-5.16,0-9.35-4.19-9.35-9.35h0Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: 118.19,
    y: 259.15,
    width: 134.17,
    height: 21.06,
    rx: 10.53,
    ry: 10.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M146.33,286.06l3.08-11.48c.48-1.78-1.15-3.41-2.93-2.93l-11.48,3.08c-1.78.48-2.37,2.7-1.07,4l1.37,1.37-5.46,5.46c-.9.9-.9,2.37,0,3.27l2.4,2.4c.9.9,2.37.9,3.27,0l5.46-5.46,1.37,1.37c1.3,1.3,3.53.71,4-1.07Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    x: 208.2,
    y: 213.24,
    width: 7.35,
    height: 24.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "215.54 214.49 208.2 214.49 207.14 210.29 216.79 210.29 215.54 214.49"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 209.04,
    y: 214.11,
    width: 6.5,
    height: 0.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "208.21 237.53 215.55 237.53 216.61 241.73 206.96 241.73 208.21 237.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 208.21,
    y: 237.14,
    width: 6.5,
    height: 0.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    x: 223.84,
    y: 213.24,
    width: 7.35,
    height: 24.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "231.19 214.49 223.84 214.49 222.78 210.29 232.43 210.29 231.19 214.49"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 224.68,
    y: 214.11,
    width: 6.5,
    height: 0.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "223.85 237.53 231.19 237.53 232.25 241.73 222.61 241.73 223.85 237.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 223.85,
    y: 237.14,
    width: 6.5,
    height: 0.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    x: 239.48,
    y: 213.24,
    width: 7.35,
    height: 24.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "246.83 214.49 239.48 214.49 238.42 210.29 248.07 210.29 246.83 214.49"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 240.32,
    y: 214.11,
    width: 6.5,
    height: 0.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "239.49 237.53 246.83 237.53 247.89 241.73 238.25 241.73 239.49 237.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 239.49,
    y: 237.14,
    width: 6.5,
    height: 0.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st11",
    x: 255.12,
    y: 213.24,
    width: 7.35,
    height: 24.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "262.47 214.49 255.12 214.49 254.06 210.29 263.71 210.29 262.47 214.49"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 255.97,
    y: 214.11,
    width: 6.5,
    height: 0.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "255.13 237.53 262.48 237.53 263.53 241.73 253.89 241.73 255.13 237.53"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 255.13,
    y: 237.14,
    width: 6.5,
    height: 0.76
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 204.7,
    y: 206.75,
    width: 61.68,
    height: 3.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st12",
    x: 204.7,
    y: 241.73,
    width: 61.68,
    height: 3.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 196.23,
    y: 245.26,
    width: 78.62,
    height: 3.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M202.82,203.97l30.4-13.39c1.87-.82,3.99-.82,5.86,0l30.4,13.39c1.44.63.99,2.78-.59,2.78h-65.49c-1.57,0-2.02-2.15-.59-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.76,199.27l9.61-4.23c3.05-1.34,6.52-1.34,9.57,0l9.61,4.23c2.35,1.03,1.61,4.54-.96,4.54h-26.88c-2.57,0-3.3-3.51-.96-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M236.15,202.07c-1.44,0-2.61-1.17-2.61-2.61s1.17-2.61,2.61-2.61,2.61,1.17,2.61,2.61-1.17,2.61-2.61,2.61ZM236.15,197.6c-1.02,0-1.85.83-1.85,1.85s.83,1.85,1.85,1.85,1.85-.83,1.85-1.85-.83-1.85-1.85-1.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 204.7,
    y: 241.34,
    width: 61.68,
    height: 0.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 204.7,
    y: 244.88,
    width: 61.68,
    height: 0.76
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 340.93,
    y: 239.17,
    width: 0.76,
    height: 7.66,
    transform: "translate(-74.14 297.25) rotate(-42.89)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 333.89,
    y: 242.01,
    width: 0.76,
    height: 8.24,
    transform: "translate(-76.14 308.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 325.42,
    y: 244.89,
    width: 0.76,
    height: 6.28,
    transform: "translate(-79.96 303.01) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M327.84,250.64c-4.4,0-8.79-.85-12.99-2.56-17.62-7.16-26.13-27.32-18.97-44.94,7.16-17.62,27.32-26.13,44.94-18.97,8.54,3.47,15.21,10.05,18.79,18.54,3.58,8.49,3.65,17.86.18,26.4l-.35-.14.35.14c-3.47,8.54-10.05,15.21-18.54,18.79-4.32,1.82-8.86,2.73-13.41,2.73ZM327.88,182.4c-13.33,0-25.97,7.95-31.29,21.03-7,17.23,1.32,36.95,18.55,43.95,8.35,3.39,17.52,3.33,25.82-.17,8.3-3.5,14.74-10.03,18.13-18.38,3.39-8.35,3.33-17.52-.17-25.82-3.5-8.3-10.03-14.74-18.38-18.13-4.14-1.68-8.44-2.48-12.66-2.48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 351.9,
    y: 228.59,
    width: 0.76,
    height: 8.91,
    transform: "translate(-61.6 317.36) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 355.56,
    y: 222.29,
    width: 0.76,
    height: 8.91,
    transform: "translate(-56.08 318.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 358.54,
    y: 216.26,
    width: 0.76,
    height: 7.01,
    transform: "translate(-50.27 318.17) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 358.7,
    y: 205.89,
    width: 0.76,
    height: 8.15,
    transform: "translate(-43.29 315.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 346.83,
    y: 233.68,
    width: 0.76,
    height: 9.31,
    transform: "translate(-66.83 315.32) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 323.02,
    cy: 212.85,
    r: 34.11,
    transform: "translate(-57.35 142.38) rotate(-22.89)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 323.02,
    cy: 212.85,
    r: 25.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M316.97,238.97c-6.55-2.66-11.68-7.72-14.43-14.23-2.75-6.52-2.8-13.71-.14-20.26,2.66-6.55,7.72-11.68,14.23-14.43,6.52-2.75,13.71-2.8,20.27-.14l-.29.71c-6.36-2.59-13.35-2.54-19.68.13-6.33,2.67-11.24,7.65-13.82,14.01s-2.54,13.35.13,19.68c2.67,6.33,7.65,11.24,14.01,13.82l-.29.71Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M324.02,225.9c-1.35,0-2.73-.36-4.02-1.07-2.89-1.6-4.68-4.67-4.57-7.82l2.67.1c-.08,2.15,1.17,4.27,3.19,5.39,1.86,1.03,3.88.98,5.54-.13,1.21-.82,2.04-2.21,2.22-3.73.18-1.5-1.15-2.98-3.94-4.37-.44-.22-.89-.43-1.33-.64-1.13-.53-2.3-1.07-3.39-1.82-2.4-1.64-3.94-4.64-3.84-7.45.08-2.23,1.19-4.08,3.13-5.21,1.26-.73,2.64-1.09,3.99-1.04,2.96.11,5.62,1.71,7.1,4.28l-2.31,1.33c-1.02-1.77-2.85-2.87-4.89-2.95-.86-.04-1.72.2-2.55.68-1.15.67-1.76,1.68-1.8,3-.07,1.87,1.06,4.04,2.68,5.15.91.62,1.93,1.1,3.01,1.6.47.22.94.44,1.4.67,3.9,1.95,5.71,4.33,5.39,7.07-.27,2.28-1.53,4.38-3.38,5.63-1.31.88-2.8,1.33-4.31,1.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 322.25,
    y: 195.96,
    width: 2.67,
    height: 33.78
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 116.94,
    y: 173.46,
    width: 8.82,
    height: 8.82,
    rx: 2,
    ry: 2,
    transform: "translate(-90.23 137.91) rotate(-45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: 352.73,
    y: 292.9,
    width: 8.82,
    height: 8.82,
    rx: 2,
    ry: 2,
    transform: "translate(-105.63 339.62) rotate(-45)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 132.44,
    cy: 195.96,
    r: 2.45
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 343.92,
    cy: 317.39,
    r: 2.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrations03);
export default __webpack_public_path__ + "static/media/illustrations-03.07ae99b7811e632bd86087f9f3bc2bcb.svg";
export { ForwardRef as ReactComponent };